import { correctingTrailingNumbers } from '@cryptoboyio/mercuryo-lab/utils';

import { GlobalTypes } from '@modules/global';
import { TransactionsTypes } from '@modules/transactions';

const getData = (
  transaction: TransactionsTypes.TransactionType,
  totalDigits?: number,
  displayDigits?: number
): {
  total: string;
  subtotal: string | number;
  currency: GlobalTypes.CurrencyEnum;
} => {
  switch (transaction.type) {
    case CONST.operations.withdraw:
      return {
        total: transaction.amount,
        subtotal: transaction.calculated_amount || '',
        currency: transaction.currency,
      };
    case CONST.operations.sell:
    default:
      return {
        total: correctingTrailingNumbers(
          transaction.calculated_amount || '',
          displayDigits,
          totalDigits
        ),
        subtotal: transaction.fiat_amount,
        currency: transaction.fiat_currency,
      };
  }
};

export default getData;
